// src/pages/AuthCallback.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Auth temporarily removed — just go to the dashboard.
    navigate('/dashboard');
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0f0f0f 100%)',
      color: '#fff'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Processing authentication...</h2>
        <p>Please wait while we verify your email.</p>
      </div>
    </div>
  );
}
